module.exports = __webpack_public_path__ + "img/Wally-DVR.01d12c79.png";